import {Environment, getEnvironment} from '@/services/infrastructure/envhelper.service'
import {TogglableFeature} from '@/feature-toggles/feature-toggler.service'

export const MultiCreateTransactionFeature: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() !== Environment.Production && getEnvironment() !== Environment.PreProduction
    }
}

export const DebtCollectionSynchronizer: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() !== Environment.Production && getEnvironment() !== Environment.PreProduction
    }
}
